var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 1V23M17.0005 5H9.50049C8.57223 5 7.68199 5.36875 7.02561 6.02513C6.36924 6.6815 6.00049 7.57174 6.00049 8.5C6.00049 9.42826 6.36924 10.3185 7.02561 10.9749C7.68199 11.6313 8.57223 12 9.50049 12H14.5005C15.4287 12 16.319 12.3687 16.9754 13.0251C17.6317 13.6815 18.0005 14.5717 18.0005 15.5C18.0005 16.4283 17.6317 17.3185 16.9754 17.9749C16.319 18.6313 15.4287 19 14.5005 19H6.00049",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.dcf66383cc4d01414248582364528a48.svg";
export { ForwardRef as ReactComponent };